import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import RHService from '../../../../../../services/rh-auth';
import { Link, useParams, Navigate } from 'react-router-dom';


const Diario = () => {
    let { id } = useParams()

    const [orgao, setOrgao] = useState("");
    const [referencia, setReferencia] = useState("");
    const [ano, setAno] = useState("");
    const [tipoEdital, setTipoEdital] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);

    async function fetchConcurso(id) {
        const response = await RHService.concursoEdit(id);
        setOrgao(response.data["orgao"]);
        setReferencia(response.data["referencia"]);
        response.data["tipoEdital"] ? setTipoEdital(response.data["tipoEdital"]) : setTipoEdital("Editar");
        setAno(response.data["ano"]);
    }

    useEffect(() => {
        fetchConcurso(id);
    }, [id]);


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const documento = await RHService.editarConcurso(id, {
                orgao: orgao,
                referencia: referencia,
                tipoEdital: tipoEdital,
                ano: ano
            })
            if (documento.data["_id"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }


    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={2}>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="Orgão">
                                <FloatingLabel
                                    label="Orgão"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Orgão"
                                        name="orgao"
                                        onChange={e => setOrgao(e.target.value)}
                                    >
                                        <option value={orgao}>{orgao}</option>
                                        <option value="Prefeitura Municipal de Macuco">Prefeitura Municipal de Macuco</option>
                                        <option value="Secretaria Municipal de Saúde">Secretaria Municipal de Saúde</option>
                                        <option value="Secretaria Municipal de Educação">Secretaria Municipal de Educação</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="ano">
                                <FloatingLabel
                                    label="Ano do Concurso"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Ano"
                                        name="ano"
                                        onChange={e => setAno(e.target.value)}
                                    >
                                        <option value={ano}>{ano}</option>
                                        <option value="2026">2026</option>
                                        <option value="2010">2010</option>
                                        <option value="2012">2012</option>
                                        <option value="2001">2001</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="Tipo de Edital">
                                <FloatingLabel
                                    label="Tipo de Edital"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Tipo de Edital"
                                        name="tipoEdital"
                                        onChange={e => setTipoEdital(e.target.value)}
                                    >
                                        <option value={tipoEdital}>{tipoEdital}</option>
                                        <option value="Edital de Abertura">Edital de Abertura</option>
                                        <option value="Edital de Convocação">Edital de Convocação</option>
                                        <option value="Resultado Final">Resultado Final</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="Ano">
                                <FloatingLabel
                                    label="Edital nº"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="number"
                                        name="referencia"
                                        value={referencia}
                                        onChange={e => setReferencia(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>

                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Salvar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/rh/concurso/listar'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Edital editado com sucesso!</Alert>
                <Navigate to={'/restrito/rh/concurso/listar'} />
            </Fragment>
        )
    }
}

export default Diario;